import { usePortal } from '@web-ui-kit/hooks.use-portal'
import PropTypes from 'prop-types'
import useNavigationOptions from '../../hooks/useNavigationOptions'
import * as Sc from './NavigationMenu.style'

const NavigationMenu = ({ isOpen, onClose }) => {
  const { render } = usePortal('sidebar-mobile')
  const { secondaryOptions, mainOptions } = useNavigationOptions()

  return render(
    <Sc.Overlay $isOpen={isOpen} aria-label='overlay' onClick={onClose}>
      <Sc.CustomSidebar
        $isOpen={isOpen}
        bottomOptions={secondaryOptions}
        onClose={onClose}
        positionTooltip='bottom'
        topOptions={mainOptions}
      />
    </Sc.Overlay>
  )
}
NavigationMenu.defaultProps = {
  isOpen: false,
}

NavigationMenu.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
}

export default NavigationMenu
